"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _uiTheme = require("@kyruus/ui-theme");
var _useGoogleMaps = _interopRequireWildcard(require("../../lib/useGoogleMaps"));
var _loadOmsPlugin = _interopRequireDefault(require("../../lib/loadOmsPlugin"));
var _map2 = require("../../lib/map.utils");
var _map3 = require("../../lib/map.constants");
var _styles = require("./styles");
var _useMarkerEvents = require("./hooks/useMarkerEvents");
var _useKeyboardEvents = require("./hooks/useKeyboardEvents");
var _useOffsetLocations = require("./hooks/useOffsetLocations");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DEFAULT_MAP_OPTIONS = {
  maxZoom: 16,
  mapTypeControl: false,
  fullscreenControl: true,
  mapId: 'DEMO_MAP_ID'
};
const noop = () => {};
const locationPropType = (0, _propTypes.shape)({
  coordinates: (0, _propTypes.shape)({
    lat: _propTypes.number,
    lon: _propTypes.number
  }),
  name: _propTypes.string,
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
});
const propTypes = {
  /**
   * Set of locations
   */
  locations: (0, _propTypes.arrayOf)(locationPropType).isRequired,
  /**
   * Currently selected location
   */
  selectedLocation: locationPropType,
  /**
   * Set of location ids with enabled markers
   * disabled markers won't trigger events like "mouseover"
   */
  enabledLocationIds: _propTypes.object,
  /**
   * callback that retunrs an array of
   * - markers: google.markers and their meta objects
   * - meta: {
   *    location: kyruus location associated with this marker,
   *    startAnimation: func to start a bounce animation on this marker
   *    stopAnimation: func to stop a bounce animation on this marker
   *    isDisabled: bool indicating if this marker is disabled
   *    isSelected: bool indicating if this marker is selected
   *  }
   *
   * @callback
   * @returns {Array<{markers: google.markers, meta: object}}
   */
  getMarkers: _propTypes.func,
  /**
   * url used to load googlemaps like:
   * 'https://maps.googleapis.com/maps/api/js?key=<KEY>&amp;language=en&amp;region=US&amp;libraries=places';
   *
   * If a url is not provided, it is assumed that `google.maps` has already been
   * loaded on the page
   */
  url: _propTypes.string,
  /**
   * map options
   */
  mapOptions: (0, _propTypes.shape)({
    maxZoom: _propTypes.number.isRequired,
    mapTypeControl: _propTypes.bool.isRequired,
    // show/hide icon for full screen mode of map view
    fullscreenControl: _propTypes.bool
  }),
  /**
   * Marker event for onClick
   */
  onMarkerClick: _propTypes.func,
  /**
   * Marker event for onmouseover
   */
  onMarkerMouseover: _propTypes.func,
  /**
   * Marker event for onmouseout
   */
  onMarkerMouseout: _propTypes.func,
  /**
   * Object mapping map event names to event handlers
   * Only valid google maps map event names will have a handler registered
   * with the exception of the STREETVIEW_EVENTS (custom implementations)
   * https://developers.google.com/maps/documentation/javascript/reference#map
   */
  mapEventsToRegister: (0, _propTypes.objectOf)((propValue, key, _componentName, _location, propFullName) => {
    var _context;
    if (!(0, _includes.default)(_context = [..._map3.MAP_EVENTS, ..._map3.STREETVIEW_EVENTS]).call(_context, key)) {
      return new Error(`Invalid prop ${propFullName}: key is not a valid Gmaps map event`);
    }
    if (typeof propValue[key] !== 'function') {
      return new Error(`Invalid prop ${propFullName}: event handler is not a function`);
    }
  }),
  /**
   * Should the map display a label (n + 1) for each location marker?
   */
  shouldLabelMarkers: _propTypes.bool,
  /**
   *
   */
  theme: (0, _propTypes.shape)({
    color_providermatch: _propTypes.string
  }),
  defaultMarkerIcon: _propTypes.string,
  /**
   * Flag for enabling markers for different states (default, hover, focused, pressed)
   */
  enableAdvancedMarkers: _propTypes.bool
};
function Gmap(_ref) {
  let {
    locations: originalLocations,
    enabledLocationIds,
    getMarkers = noop,
    url = '',
    mapOptions = DEFAULT_MAP_OPTIONS,
    onMarkerClick = noop,
    onMarkerMouseover = noop,
    onMarkerMouseout = noop,
    mapEventsToRegister = {},
    shouldLabelMarkers = true,
    selectedLocation,
    theme,
    defaultMarkerIcon,
    enableAdvancedMarkers = false,
    ...props
  } = _ref;
  const containerRef = (0, _react.useRef)();
  const mapRef = (0, _react.useRef)();
  const omsRef = (0, _react.useRef)();
  const streetviewPanoramaRef = (0, _react.useRef)();
  const markersRef = (0, _react.useRef)([]);
  const {
    status: gMapsStatus,
    gMaps
  } = (0, _useGoogleMaps.default)(url);
  const oms = (0, _react.useMemo)(_loadOmsPlugin.default, []);
  const locations = (0, _useOffsetLocations.useOffsetLocations)(originalLocations, enableAdvancedMarkers);
  const events = (0, _useMarkerEvents.useMarkerEvents)({
    onMarkerClick,
    enableAdvancedMarkers,
    enabledLocationIds,
    selectedLocation,
    gMaps,
    theme,
    defaultMarkerIcon,
    onMarkerMouseover,
    onMarkerMouseout,
    markersRef
  });
  const keyboardEvents = (0, _useKeyboardEvents.useKeyboardEvents)({
    onMarkerClick,
    enableAdvancedMarkers,
    enabledLocationIds,
    gMaps,
    theme,
    defaultMarkerIcon,
    markersRef
  });
  const isLoaded = gMapsStatus === _useGoogleMaps.statuses.LOADED;
  const isMapError = gMapsStatus === _useGoogleMaps.statuses.ERROR;

  // Sync current map ref and current markers ref if locations change
  (0, _react.useEffect)(() => {
    var _context2, _context3;
    if (!isLoaded) {
      return;
    }
    const currentEnabledLocationIds = new _set.default((0, _map.default)(_context2 = markersRef.current).call(_context2, _ref2 => {
      let {
        meta
      } = _ref2;
      return meta.location.id;
    }));
    if (!mapRef.current) {
      mapRef.current = new gMaps.Map(containerRef.current, {
        ...mapOptions,
        ...(enableAdvancedMarkers ? {
          mapId: DEFAULT_MAP_OPTIONS.mapId
        } : {})
      });
    }
    if (!omsRef.current) {
      // OverlappingMarkerSpiderfier https://github.com/jawj/OverlappingMarkerSpiderfier
      omsRef.current = new oms(mapRef.current, {
        markersWontMove: true,
        // we promise not to move any markers, allowing optimizations
        markersWontHide: true,
        // we promise not to change visibility of any markers, allowing optimizations
        keepSpiderfied: true // an expanded group of markers will stay expanded when one of them is clicked (defaults to false, will unexpand markers when one is clicked)
      });
      omsRef.current.legColors.usual['roadmap'] = (0, _uiTheme.fromTheme)('color_text_contrast')({
        theme
      });
      omsRef.current.legColors.highlighted['roadmap'] = (0, _uiTheme.fromTheme)('color_providermatch')({
        theme
      });
    }

    // only if there any mapEventsToRegister that are also STREETVIEW_EVENTS,
    // then set up a streetviewPanoramaRef to disable the default UI, etc.
    if (!streetviewPanoramaRef.current && (0, _some.default)(_context3 = (0, _keys.default)(mapEventsToRegister)).call(_context3, ev => (0, _includes.default)(_map3.STREETVIEW_EVENTS).call(_map3.STREETVIEW_EVENTS, ev))) {
      streetviewPanoramaRef.current = mapRef.current.getStreetView();
      // disable default streetview UI controls so we can avoid clashes between their UI and ours
      streetviewPanoramaRef.current.setOptions({
        disableDefaultUI: true,
        enableCloseButton: false
      });
    }
    const shouldUpdateMarkers = enableAdvancedMarkers && (0, _map2.hasLocationsChanged)(markersRef.current, locations) || !(0, _map2.isEqualSets)(enabledLocationIds, currentEnabledLocationIds);
    if (shouldUpdateMarkers) {
      if (enableAdvancedMarkers) {
        var _context4;
        (0, _forEach.default)(_context4 = markersRef.current).call(_context4, _ref3 => {
          let {
            marker,
            meta
          } = _ref3;
          marker.removeListeners(meta);
          marker.setMap(null);
        });
      } else {
        (0, _map2.clearMarkers)(markersRef.current);
      }
      markersRef.current = [];
      if (locations.length > 0) {
        const markers = (0, _map2.addMarkers)({
          gMaps,
          oms: omsRef.current,
          locations,
          bounds: new gMaps.LatLngBounds(),
          map: mapRef.current,
          shouldLabelMarkers,
          theme,
          useAdvancedMarkers: enableAdvancedMarkers
        });
        (0, _forEach.default)(markers).call(markers, _ref4 => {
          let {
            marker,
            meta
          } = _ref4;
          for (const ev in events) {
            const handle = marker.addListener(ev, () => {
              events[ev]({
                marker,
                meta
              });
            });
            meta.eventListeners.push(handle);
          }

          // Add keyboard event listeners for advanced markers
          if (enableAdvancedMarkers) {
            for (const ev in keyboardEvents) {
              const handler = event => {
                keyboardEvents[ev]({
                  marker,
                  meta,
                  event
                });
              };
              marker.addListener(ev, handler);
              meta.eventListeners.push({
                eventName: ev,
                handler,
                remove: () => marker.removeListener(ev, handler)
              });
            }
          }
          if (!enableAdvancedMarkers) {
            const handle = gMaps.event.addListener(marker, 'spider_format', format => {
              var _context5, _context6;
              if ((0, _includes.default)(_context5 = ['SPIDERFIED', 'UNSPIDERFIABLE']).call(_context5, format)) {
                marker.setTitle(meta.location.name);
              }
              if ((0, _includes.default)(_context6 = ['UNSPIDERFIED', 'SPIDERFIABLE']).call(_context6, format)) {
                marker.setTitle('Expand multiple pins at this location');
              }
            });
            meta.eventListeners.push(handle);
          }
        });
        (0, _map2.updateMarkersState)({
          markers,
          enabledLocationIds,
          selectedLocation,
          gMaps,
          theme,
          defaultMarkerIcon,
          enableAdvancedMarkers
        });
        markersRef.current = markers;
      }
      if (getMarkers) {
        getMarkers(markersRef.current);
      }
    }
  }, [enabledLocationIds, selectedLocation, getMarkers, locations, gMaps, oms, onMarkerClick, mapOptions, shouldLabelMarkers, mapEventsToRegister, isLoaded, theme, defaultMarkerIcon, enableAdvancedMarkers, events, keyboardEvents]);

  // Hook up map-level event listeners
  (0, _react.useEffect)(() => {
    if (!isLoaded) {
      return;
    }
    const eventListenersForCleanup = [];
    if (mapRef.current) {
      var _context7;
      (0, _forEach.default)(_context7 = (0, _entries.default)(mapEventsToRegister)).call(_context7, _ref5 => {
        let [event, cb] = _ref5;
        // STREETVIEW_EVENTS are custom implementations (not in official google maps api)
        if ((0, _includes.default)(_map3.STREETVIEW_EVENTS).call(_map3.STREETVIEW_EVENTS, event) && typeof cb === 'function') {
          const handle = (() => {
            switch (event) {
              case 'streetview_entered':
                {
                  const handleStreetviewEntered = () => {
                    if (streetviewPanoramaRef.current.getVisible() === true) {
                      cb(mapRef, streetviewPanoramaRef);
                    }
                  };
                  return streetviewPanoramaRef.current.addListener('visible_changed', handleStreetviewEntered);
                }
              case 'streetview_exited':
                {
                  const handleStreetViewExited = () => {
                    if (streetviewPanoramaRef.current.getVisible() === false) {
                      cb(mapRef, streetviewPanoramaRef);
                    }
                  };
                  return streetviewPanoramaRef.current.addListener('visible_changed', handleStreetViewExited);
                }
              default:
                return undefined;
            }
          })();
          if (handle) {
            // store reference to event listener for cleanup
            eventListenersForCleanup.push(handle);
          }
        }

        // MAP_EVENTS are standard google maps api events
        if ((0, _includes.default)(_map3.MAP_EVENTS).call(_map3.MAP_EVENTS, event) && typeof cb === 'function') {
          const handle = mapRef.current.addListener(event, () => {
            cb(mapRef);
          });
          // store reference to event listener for cleanup
          eventListenersForCleanup.push(handle);
        }
      });
    }
    return () => {
      (0, _forEach.default)(eventListenersForCleanup).call(eventListenersForCleanup, handle => handle.remove());
    };
  }, [mapEventsToRegister, isLoaded, enableAdvancedMarkers]);

  // Sync disabled/enabled/selected state for markers if things changes
  (0, _react.useEffect)(() => {
    (0, _map2.updateMarkersState)({
      markers: markersRef.current,
      enabledLocationIds,
      selectedLocation,
      gMaps,
      theme,
      defaultMarkerIcon,
      enableAdvancedMarkers
    });
  }, [gMaps, markersRef, enabledLocationIds, selectedLocation, theme, defaultMarkerIcon, enableAdvancedMarkers]);
  if (isMapError) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !isLoaded && /*#__PURE__*/_react.default.createElement(_styles.Loading, null), /*#__PURE__*/_react.default.createElement(_styles.Container, (0, _extends2.default)({}, props, {
    isLoaded: isLoaded,
    ref: containerRef,
    "data-testid": "Gmap"
  })));
}
Gmap.propTypes = propTypes;
var _default = exports.default = Gmap;
Gmap.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Gmap",
  "props": {
    "getMarkers": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "callback that retunrs an array of\n- markers: google.markers and their meta objects\n- meta: {\n   location: kyruus location associated with this marker,\n   startAnimation: func to start a bounce animation on this marker\n   stopAnimation: func to stop a bounce animation on this marker\n   isDisabled: bool indicating if this marker is disabled\n   isSelected: bool indicating if this marker is selected\n }\n\n@callback\n@returns {Array<{markers: google.markers, meta: object}}",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "url": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "url used to load googlemaps like:\n'https://maps.googleapis.com/maps/api/js?key=<KEY>&amp;language=en&amp;region=US&amp;libraries=places';\n\nIf a url is not provided, it is assumed that `google.maps` has already been\nloaded on the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "mapOptions": {
      "defaultValue": {
        "value": "{\n  maxZoom: 16,\n  mapTypeControl: false,\n  fullscreenControl: true,\n  mapId: 'DEMO_MAP_ID'\n}",
        "computed": false
      },
      "description": "map options",
      "type": {
        "name": "shape",
        "value": {
          "maxZoom": {
            "name": "number",
            "required": true
          },
          "mapTypeControl": {
            "name": "bool",
            "required": true
          },
          "fullscreenControl": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "onMarkerClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Marker event for onClick",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMarkerMouseover": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Marker event for onmouseover",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onMarkerMouseout": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Marker event for onmouseout",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "mapEventsToRegister": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Object mapping map event names to event handlers\nOnly valid google maps map event names will have a handler registered\nwith the exception of the STREETVIEW_EVENTS (custom implementations)\nhttps://developers.google.com/maps/documentation/javascript/reference#map",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "custom",
          "raw": "(propValue, key, _componentName, _location, propFullName) => {\n  if (![...MAP_EVENTS, ...STREETVIEW_EVENTS].includes(key)) {\n    return new Error(\n      `Invalid prop ${propFullName}: key is not a valid Gmaps map event`\n    );\n  }\n  if (typeof propValue[key] !== 'function') {\n    return new Error(\n      `Invalid prop ${propFullName}: event handler is not a function`\n    );\n  }\n}"
        }
      },
      "required": false
    },
    "shouldLabelMarkers": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Should the map display a label (n + 1) for each location marker?",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "enableAdvancedMarkers": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag for enabling markers for different states (default, hover, focused, pressed)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "locations": {
      "description": "Set of locations",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "locationPropType"
        }
      },
      "required": true
    },
    "selectedLocation": {
      "description": "Currently selected location",
      "type": {
        "name": "custom",
        "raw": "locationPropType"
      },
      "required": false
    },
    "enabledLocationIds": {
      "description": "Set of location ids with enabled markers\ndisabled markers won't trigger events like \"mouseover\"",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "theme": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "color_providermatch": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "defaultMarkerIcon": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};